import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function ScrollAnimation(el) {
  const container = el.querySelector('#lottie-container');
  const { videoUrlDesktop, videoUrlMobile } = el.dataset;

  if (container && videoUrlDesktop && videoUrlMobile) {
    // Ensure the container fits the viewport so the animation isn't cut off
    container.style.width = '100%';
    container.style.height = '100vh';
    container.style.display = 'flex';
    container.style.alignItems = 'center';
    container.style.justifyContent = 'center';
    container.style.background = 'black';

    const video = document.createElement('video');

    video.muted = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.style.width = '100%';
    video.style.height = '100%';
    video.style.objectFit = 'contain';

    container.innerHTML = '';
    container.appendChild(video);

    // Ensure the video is loaded before setting up ScrollTrigger
    video.addEventListener('loadedmetadata', () => {
      // Hack for iOS to ensure frames render during scrub
      // Playing and pausing briefly "wakes up" the decoder
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            video.pause();
          })
          .catch(() => {
            // Auto-play was prevented, but scrubbing might still work
          });
      }

      gsap.to(video, {
        currentTime: video.duration,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top top',
          end: '+=3000', // Fixed scroll distance (3000px)
          pin: true,
          scrub: true,
          anticipatePin: 1,
        },
      });
    });

    if (window.innerWidth < 1024) {
      video.src = videoUrlMobile;
    } else {
      video.src = videoUrlDesktop;
    }
  }
}

export default ScrollAnimation;
